import { FC } from "react";
import styled from "styled-components";

import { Td } from "@/components/Table";
import { TestingCompetitionParticipantsResource } from "@/types/resources";
import { ReactComponent as GoldMedal } from "@/assets/icons/gold-medal.svg";
import { ReactComponent as SilverMedal } from "@/assets/icons/silver-medal.svg";
import { ReactComponent as BronzeMedal } from "@/assets/icons/bronze-medal.svg";

export const ParticipantHolder = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 6px;
    flex-shrink: 0;
  }
`;

interface Props {
  participant: TestingCompetitionParticipantsResource;
  winnersByWins?: number[];
  winnersByCtr?: number[];
}

const ParticipantsPerformanceTableRow: FC<Props> = ({
  participant,
  winnersByWins,
  winnersByCtr,
}) => {
  const renderWinsMedal = (userId: number) => {
    if (winnersByWins?.indexOf(userId) === 0) {
      return <GoldMedal />;
    }
    if (winnersByWins?.indexOf(userId) === 1) {
      return <SilverMedal />;
    }
    if (winnersByWins?.indexOf(userId) === 2) {
      return <BronzeMedal />;
    }
  };

  const renderCtrMedal = (userId: number) => {
    if (winnersByCtr?.indexOf(userId) === 0) {
      return <GoldMedal />;
    }
    if (winnersByCtr?.indexOf(userId) === 1) {
      return <SilverMedal />;
    }
    if (winnersByCtr?.indexOf(userId) === 2) {
      return <BronzeMedal />;
    }
  };
  return (
    <tr>
      <Td>{participant.name}</Td>
      <Td>{participant.currentCompetitions ?? "-"}</Td>
      <Td>{participant.totalVariations ?? "-"}</Td>
      <Td>
        {participant.maxCtr ? (
          <ParticipantHolder>
            {renderCtrMedal(participant.userId)} {participant.maxCtr} %
          </ParticipantHolder>
        ) : (
          "-"
        )}
      </Td>
      <Td>
        <ParticipantHolder>
          {renderWinsMedal(participant.userId)} {participant.totalWins}
        </ParticipantHolder>
      </Td>
    </tr>
  );
};

export default ParticipantsPerformanceTableRow;
